<template>
  <div class="content">
    <div class="inner_content">
      <div class="header">促销活动</div>
      <div class="panel">
        <div class="box" v-for="(item, index) in promotionData" :key="index">
          <div class="box-inline flex" @click="go(item.url)">
            <div class="box-left">
              <img :src="item.img" alt />
            </div>
            <div class="box-right">
              <div class="box-right-top">{{ item.title }}</div>
              <div class="box-right-bottom">{{ item.explain }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="header">客户营销</div>
      <div class="panel">
        <div class="box" v-for="(item, index) in clientData" :key="index">
          <div class="box-inline flex" @click="go(item.url)">
            <div class="box-left">
              <img :src="item.img" alt />
            </div>
            <div class="box-right">
              <div class="box-right-top">{{ item.title }}</div>
              <div class="box-right-bottom">{{ item.explain }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      promotionData: [
        // {
        //   img: require("@public/img/market/quan.png"),
        //   title: "直接发券",
        //   explain: "自主选定客户群，进行...",
        //   url: "marketing/salesPromotion/promoCode"
        // },
        // {
        //   img: require("@public/img/market/youhui.png"),
        //   title: "优惠码",
        //   explain: "领专属码，享多重好礼",
        //   url: ""
        // },
        // {
        //   img: require("@public/img/market/zhekou.png"),
        //   title: "限时折扣",
        //   explain: "商品限时打折促销",
        //   url: "marketing/salesPromotion/discount"
        // },
        // {
        //   img: require("@public/img/market/manzeng.png"),
        //   title: "分销中心",
        //   explain: "邀请好友，一起赚钱",
        //   url: "/apply/distribute/10/general"
        // },
        {
          img: require("@public/img/market/quan.png"),
          title: "优惠券",
          explain: "券动客心，营销必备",
          url: "marketing/salesPromotion/shellDiscount"
        },
        {
          img: require("@public/img/market/jindian.png"),
          title: "积分商城",
          explain: "积分兑换，促进消费",
          url: "marketing/salesPromotion/shellIntegral"
        },
        {
          img: require("@public/img/market/guanzhu.png"),
          title: "积分抵扣",
          explain: "消费时低分抵扣设置",
          url: "marketing/salesPromotion/pointSetting"
        },
        {
          img: require("@public/img/market/guanzhu.png"),
          title: "消分任务",
          explain: "积分减",
          url: "marketing/salesPromotion/integralTask"
        }
      ],
      clientData: [
        {
          img: require("@public/img/market/xiaofei.png"),
          title: "消费后有礼",
          explain: "只要客户进行消费",
          url: "marketing/client/consumption/consumption-list"
        },
        // {
        //   img: require("@public/img/market/shangri.png"),
        //   title: "大转盘",
        //   explain: "支付后营销",
        //   url: "/apply/luckyDraw/22/turntableList"
        // },
        {
          img: require("@public/img/market/chongzhi.png"),
          title: "充值有礼",
          explain: "只要客户进行消费",
          url: "marketing/client/rechange/rechange-list"
        },
        // {
        //   img: require("@public/img/market/chongzhi.png"),
        //   title: "价立减",
        //   explain: "促销降价暖心回馈",
        //   url: "marketing/client/rechargeSet"
        // },
        // {
        //   img: require("@public/img/market/jieri.png"),
        //   title: "节日有礼",
        //   explain: "只要客户进行消费",
        //   url: "marketing/client/holiday/holiday-list"
        // },
        {
          img: require("@public/img/market/qiandao.png"),
          title: "签到有礼",
          explain: "只要客户进行消费",
          url: "marketing/client/sign/signData/set"
        },
        {
          img: require("@public/img/market/guanzhu.png"),
          title: "关注有礼",
          explain: "只要客户进行消费",
          url: "marketing/client/attention/attention-list"
        },
        // {
        //   img: require("@public/img/market/quan.png"),
        //   title: "短信群发",
        //   explain: "以短信的形式通知客户某些重要信息",
        //   url: "marketing/client/note/note-list"
        // },
        {
          img: require("@public/img/market/jindian.png"),
          title: "群发服务设置",
          explain:
            "发送内容的编辑                                                                                                                                                                                                                                                                                                                                                                                                                                              ",
          url: "marketing/client/active"
        },
        // {
        //   img: require("@public/img/market/qiandao.png"),
        //   title: "推送服务",
        //   explain: "利用微信客服消息接口，唤醒粉丝活跃，提高转化",
        //   url: "marketing/client/push/activeIndex"
        // },
        {
          img: require("@public/img/market/jieri.png"),
          title: "商家联盟",
          explain: "商家联盟上新了",
          url: "marketing/client/integral/integral-audit"
        },
        {
          img: require("@public/img/market/guanzhu.png"),
          title: "推荐有礼",
          explain: "邀请用户消费获得奖励",
          url: "marketing/client/invite/inviteList"
        },
        {
          img: require("@public/img/market/shangri.png"),
          title: "抽奖活动",
          explain: "邀请用户可得抽奖次数",
          url: "marketing/client/lottery/index"
        },
        {
          img: require("@public/img/market/qiandao.png"),
          title: "抖音霸屏",
          explain: "现推出抖音营销活动",
          url: "marketing/client/activity_Douyin/index"
        },
        {
          img: require("@public/img/market/shangri.png"),
          title: "散客优惠",
          explain: "散客",
          url: "marketing/client/dispersion/dispersion_input"
        },
        {
          img: require("@public/img/market/guanzhu.png"),
          title: "消费任务",
          explain: "做任务享优惠",
          url: "marketing/salesPromotion/Mission_activities/index"
        },
        {
          img: require("@public/img/market/guanzhu.png"),
          title: "群发积分模板",
          explain: "消息群发",
          url: "marketing/client/group_points"
        },
      ]
    };
  },
  mounted() {},
  methods: {
    go(path) {
      console.log("path", path);
      this.$router.push(path);
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 20px 26px 11px 20px;
  height: 100vh;
  border: 1px solid #f1f1f1;
  overflow: auto;
  min-width: 900px;
  background: rgba(240, 242, 245, 1);
  .inner_content {
    background: #fff;
    padding: 0 24px;
    height: 100%;
    .header {
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      border-bottom: 1px solid #f1f1f1;
    }
    .panel {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      padding-top: 24px;
      .box {
        cursor: pointer;
        .box-inline {
          width: 290px;
          height: 72px;
          background: rgba(247, 248, 250, 1);
          border-radius: 3px;
          padding: 16px;
          margin: 0 15px 15px 0;
          .box-left {
            width: 45px;
            height: 45px;
            margin-right: 16px;
            img {
              width: 100%;
            }
          }
          .box-right {
            > div {
              height: 23px;
            }
            .box-right-top {
              font-size: 14px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: rgba(0, 0, 0, 0.75);
            }
            .box-right-bottom {
              font-weight: 400;
              color: rgba(0, 0, 0, 0.45);
            }
          }
        }
      }
    }
  }
}
// 通用样式
.flex {
  display: flex;
  align-items: center;
  padding: 10px 0px;
  .title {
    width: 100px;
    text-align: right;
  }
}
.color-red {
  color: red;
  padding-right: 10px;
}
.color-blue {
  color: #409eff;
}
</style>
